import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import reviewsData from "./reviewsData";
import ReviewCard from "./ReviewCard";
import "./Reviews.css";
import { pageMeta } from "../../config/helmetConfig";
import { updateMetaTags } from "../../utils/metaManager";
import GoogleReviewBanner from "./GoogleReviewsBanner";

export default function Reviews() {
  useEffect(() => {
    updateMetaTags(pageMeta.reviews);
  }, []);
  return (
    <div className="reviews-page-container">
      <div className="reviews-brick-background"></div>

      <div className="reviews-content-section">
        {/* Modern Header Section */}
        <div className="reviews-header-section">
          <Container fluid className="px-3">
            <h1 className="reviews-title">Customer Reviews</h1>
            <div className="reviews-intro-card">
              <p className="reviews-description">
                Words From Our Fabulous Clients! It makes us so happy to see the
                number of positive reviews Style Emporium gets on a regular basis.
                The number of referrals and repeat customers is also proof that we
                are performing an outstanding service for our clients.
              </p>
              <GoogleReviewBanner />
            </div>
          </Container>
        </div>

        {/* Reviews Grid Section */}
        <div className="reviews-grid-section">
          <div className="reviews-grid-container">
            <Row className="justify-content-center">
              {reviewsData.map((review, index) => (
                <Col
                  key={index}
                  xs={12}
                  md={6}
                  lg={4}
                  className="d-flex justify-content-center mb-4"
                >
                  <ReviewCard review={review} />
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
